import styled from 'styled-components';
import { font, breakpoint } from 'styles/globals';

export const Container = styled.span`
    display: flex;
    gap: 8px;
    margin-top: 16px;

    .link {
        align-items: center;
        display: flex;
    }

    @media (${breakpoint.mdMin}) {
        margin-top: 0;
    }

`;

export const PoweredBy = styled.span`
    font-family: ${font.graphikCond};
    font-size: 14px;
    letter-spacing: .5px;
`;
